import type {
  ErrorLike,
  EditorSDK,
} from '@wix/wix-data-client-common-standalone'
import { findError } from '@wix/wix-data-client-common-standalone'

export const listAllControllers = async (editorSdkProxy: EditorSDK) => {
  try {
    return await editorSdkProxy.controllers.listAllControllers()
  } catch (err) {
    if (
      findError(err, (error: ErrorLike): error is ErrorLike =>
        /Cannot read properties of undefined \(reading '0'\)|^undefined is not an object/.test(
          error.message,
        ),
      )
    ) {
      return []
    }

    throw new Error('Failed to list all controllers', { cause: err })
  }
}
